import { render } from "./AIAssistantDrawer.vue?vue&type=template&id=0dcf28b1&scoped=true"
import script from "./AIAssistantDrawer.vue?vue&type=script&lang=js"
export * from "./AIAssistantDrawer.vue?vue&type=script&lang=js"

import "./AIAssistantDrawer.vue?vue&type=style&index=0&id=0dcf28b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcf28b1"]])

export default __exports__